<p-card styleClass="sales-letter-card shadow-2 border-round">
  <ng-template pTemplate="header">
    <div class="text-center p-4 bg-primary border-round-top">
      <h2 class="text-white mt-0 mb-2 text-4xl">🎉 ¡Una Oportunidad Única te Espera! 🎉</h2>
      <p class="text-primary-50 text-xl mt-0">Únete a la Revolución del Aprendizaje de Idiomas con Polilan</p>
    </div>
  </ng-template>

  <div class="p-4">
    <p class="text-lg line-height-3">Estimado futuro políglota,</p>

    <p class="text-lg line-height-3">
      Polilan está en su fase de <strong>pre-lanzamiento</strong>, y para celebrarlo, te ofrecemos la <strong>mejor oferta que jamás haremos</strong>. Sé uno de
      los primeros en descubrir una nueva forma de aprender idiomas antes del <strong>20/Julio/2025</strong>.
    </p>

    <p-messages severity="info" styleClass="mt-3 mb-4">
      <ng-template pTemplate>
        <div class="ml-2">Polilan es una aplicación innovadora diseñada para superar la efectividad de las apps de idiomas existentes.</div>
      </ng-template>
    </p-messages>

    <p class="text-lg line-height-3 mb-4">
      Descubre en este video por qué <strong>Polilan es tu mejor aliado para aprender inglés</strong> y las metodologías de vanguardia que utilizamos:
    </p>

    <div class="video-container mb-5" style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; background: #000">
      <iframe
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        src="https://www.youtube.com/embed/no2S_jW__VI?si=_HEYW_8Aaasb-YPS"
        title="Presentación Polilan"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen></iframe>
    </div>

    <p-divider align="center" styleClass="my-5">
      <span class="p-tag p-tag-info text-lg">Tu Acceso Exclusivo</span>
    </p-divider>

    <h3 class="text-2xl font-semibold mb-3 text-center">🌟 ¿Qué Obtienes con Esta Oferta Irrepetible? 🌟</h3>

    <p class="text-xl text-center font-bold text-primary mb-5">
      ¡Tres años de acceso completo a Polilan! Tiempo más que suficiente para dominar el inglés y ¡mucho más!
    </p>

    <div class="grid">
      <div class="col-12 md:col-6">
        <p-panel header="Acceso Ilimitado a lo Esencial" styleClass="h-full">
          <ul class="list-none p-0 m-0 line-height-3">
            <li class="flex align-items-center mb-2"><i class="pi pi-check-circle text-green-500 mr-2"></i> Guarda palabras sin límites.</li>
            <li class="flex align-items-center"><i class="pi pi-check-circle text-green-500 mr-2"></i> Practica con todos nuestros ejemplos.</li>
          </ul>
        </p-panel>
      </div>
      <div class="col-12 md:col-6">
        <p-panel header="Funcionalidades Premium Desbloqueadas" styleClass="h-full">
          <ul class="list-none p-0 m-0 line-height-3">
            <li class="flex align-items-center mb-2"><i class="pi pi-star-fill text-yellow-500 mr-2"></i> Lecciones estructuradas.</li>
            <li class="flex align-items-center mb-2"><i class="pi pi-star-fill text-yellow-500 mr-2"></i> Escenarios interactivos.</li>
            <li class="flex align-items-center mb-2"><i class="pi pi-star-fill text-yellow-500 mr-2"></i> Práctica de conversaciones.</li>
            <li class="flex align-items-center"><i class="pi pi-star-fill text-yellow-500 mr-2"></i> Recomendaciones personalizadas por IA.</li>
          </ul>
        </p-panel>
      </div>
    </div>

    <p-divider align="center" styleClass="my-5">
      <span class="p-tag p-tag-warning text-lg">Mirando al Futuro</span>
    </p-divider>

    <h3 class="text-2xl font-semibold mb-3 text-center">🚀 Acceso Anticipado al Futuro del Aprendizaje 🚀</h3>
    <p class="text-lg line-height-3 mb-4">
      La tecnología avanza, ¡y Polilan también! Con tu acceso de 3 años, serás testigo y beneficiario de todas las mejoras, nuevas funcionalidades e idiomas que
      añadiremos. ¡Todo sin coste adicional! Prepárate para hablar inglés fluidamente y explorar nuevos horizontes lingüísticos.
    </p>

    <p-fieldset legend="Próximamente en Polilan" [toggleable]="true" [collapsed]="true" styleClass="mb-5">
      <ul class="list-none p-0 m-0 line-height-3">
        <li class="flex align-items-center mb-2"><i class="pi pi-mobile mr-2"></i> Acceso desde Android (Jun/2025).</li>
        <li class="flex align-items-center mb-2"><i class="pi pi-apple mr-2"></i> Acceso desde iOS (iPhone, iPad) (Jun/2025).</li>
        <li class="flex align-items-center mb-2"><i class="pi pi-sparkles mr-2"></i> Mejoras tecnológicas continuas.</li>
        <li class="flex align-items-center mb-2"><i class="pi pi-book mr-2"></i> Conjugador de Verbos avanzado.</li>
        <li class="flex align-items-center mb-2"><i class="pi pi-volume-up mr-2"></i> Vocalizador para práctica de pronunciación.</li>
        <li class="flex align-items-center mb-2"><i class="pi pi-language mr-2"></i> Nuevos idiomas: Alemán, Japonés, Árabe y más.</li>
        <li class="flex align-items-center"><i class="pi pi-puzzle mr-2"></i> Integración de nuevos componentes interactivos.</li>
      </ul>
    </p-fieldset>

    <p-divider align="center" styleClass="my-5">
      <span class="p-tag p-tag-success text-lg">Tu Transformación</span>
    </p-divider>

    <h3 class="text-2xl font-semibold mb-4 text-center">🌈 Imagina Tu Nueva Realidad 🌈</h3>
    <div class="grid text-center">
      <div class="col-12 md:col-3">
        <i class="pi pi-comments text-4xl text-blue-500 mb-2"></i>
        <p class="font-medium">Confianza al Hablar</p>
        <p>¡Adiós al "lo entiendo, pero no lo hablo"!</p>
      </div>
      <div class="col-12 md:col-3">
        <i class="pi pi-chart-line text-4xl text-green-500 mb-2"></i>
        <p class="font-medium">Mejores Oportunidades</p>
        <p>Accede a salarios más altos y crecimiento profesional.</p>
      </div>
      <div class="col-12 md:col-3">
        <i class="pi pi-globe text-4xl text-purple-500 mb-2"></i>
        <p class="font-medium">Viaja Sin Barreras</p>
        <p>Comunícate con personas de todo el mundo.</p>
      </div>
      <div class="col-12 md:col-3">
        <i class="pi pi-check-square text-4xl text-teal-500 mb-2"></i>
        <p class="font-medium">Satisfacción Personal</p>
        <p>La increíble sensación de lograr conversar fluidamente.</p>
      </div>
    </div>

    <p-divider styleClass="my-5"></p-divider>

    <div class="text-center p-4 bg-red-600 text-white border-round">
      <h2 class="mt-0 mb-3 text-4xl">🔥 ¡Actúa Ahora! Oferta por Tiempo Limitado 🔥</h2>
      <p class="text-xl mt-0 mb-4 line-height-3">Invierte en ti y en una habilidad para toda la vida. Esta oportunidad única no volverá.</p>
      <p class="text-lg font-semibold">La oferta termina:</p>
      <ul class="list-none p-0 m-0 text-lg">
        <li class="mb-1"><i class="pi pi-calendar-times mr-2"></i> Al finalizar el <strong>20/Julio/2025</strong>.</li>
        <li><i class="pi pi-users mr-2"></i> O al alcanzar los <strong>1000 usuarios premium</strong> (¡cupo limitado!).</li>
      </ul>
    </div>

    <p-divider align="center" styleClass="my-5">
      <span class="p-tag p-tag-info text-lg">Inversión Inteligente</span>
    </p-divider>

    <h3 class="text-2xl font-semibold mb-3 text-center">💰 Una Inversión Incomparable en Tu Futuro 💰</h3>
    <div class="text-center mb-4">
      <p class="text-3xl font-bold text-primary my-3">
        Solo $127 USD (o $2500 MXN) <br />
        ¡por 3 AÑOS COMPLETOS de acceso!
      </p>
    </div>

    <div class="surface-100 p-3 border-round mb-5">
      <p class="text-lg font-semibold text-center mt-0 mb-3">Compara y Ahorra:</p>
      <ul class="list-none p-0 m-0 text-center line-height-3">
        <li class="mb-1"><span style="text-decoration: line-through">Precio prelanzamiento anual: $89 USD/año</span></li>
        <li class="mb-2">Precio final anual regular: $197 USD/año</li>
        <li class="font-bold text-green-600 text-xl">¡Tu ahorro supera los $464 USD en 3 años!</li>
      </ul>
    </div>

    <p-messages severity="warn" styleClass="mt-3 mb-4">
      <ng-template pTemplate>
        <div class="ml-2 text-lg"
          ><strong>Recuerda:</strong> Solo hay un pre-lanzamiento. Esta oferta <strong>jamás se repetirá</strong> y es hasta agotar cupo. ¡Asegura tu lugar
          ahora!</div
        >
      </ng-template>
    </p-messages>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-center p-4 border-top-1 surface-border">
      <p-button
        (click)="createStripeSession(36)"
        [disabled]="isLoadingStripe"
        label="¡Sí! Quiero 3 Años de Polilan con la Mejor Oferta"
        icon="pi pi-lock"
        size="large"
        styleClass="p-button-success p-button-lg" />
    </div>
  </ng-template>
</p-card>

<!-- Add some basic styles if needed, or rely on PrimeNG/PrimeFlex -->
<style>
  .sales-letter-card .p-card-content {
    padding: 0 !important; /* Remove default card content padding */
  }
  .video-container iframe {
    border-radius: 6px; /* Optional: rounds video corners */
  }
</style>
